import loanOrderList from '../../views/loan-manage/loan-order-list.vue';
import loanDetail from '../../views/loan-manage/loan-detail.vue';
import loanAgreementList from '../../views/loan-manage/loan-agreement-list.vue';
var loanManage = [
    {
        name: 'merchantLoanOrderList',
        path: 'loan-order-list',
        component: loanOrderList,
    },
    {
        name: 'loanDetail',
        path: 'loan-detail',
        component: loanDetail,
    },
    {
        name: 'loanAgreementList',
        path: 'agreement-list',
        component: loanAgreementList,
    },
];
export default loanManage;
